module.exports = __webpack_public_path__ + "static/media/plus.8e099a0d.svg";